import { render } from "./SelectIconGrid.vue?vue&type=template&id=5a8bdd34&scoped=true"
import script from "./SelectIconGrid.vue?vue&type=script&lang=js"
export * from "./SelectIconGrid.vue?vue&type=script&lang=js"

import "./SelectIconGrid.vue?vue&type=style&index=0&id=5a8bdd34&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8bdd34"]])

export default __exports__